module.exports = __webpack_public_path__ + "img/ruanJian1.7d54e9b7.png";